import styled from "styled-components";
import media from "styled-media-query";

import PressCell, { Props as PressCellProps } from "../cell/PressCell";
import { useEffect, useState } from "react";
import { Button, ColorV2 } from "@adoptaunabuelo/react-components";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useSelector } from "react-redux";
import { State } from "../../redux";

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;
const ButtonRow = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 8px;
	${media.lessThan("medium")`
		display: none;
	`}
`;
const CellRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 16px;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan("medium")`
		overflow-x: auto;
		scroll-snap-type: x mandatory;
		scroll-padding-left: 24px;
		width: 100vw;
		margin: 0px -24px;
		padding: 0px 24px;
		box-sizing: border-box;
	`}
`;

const PressList = (props: Props) => {
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const [index, setIndex] = useState(0);
	const [nCells, setNCells] = useState(props.nCells ? props.nCells : 2);

	useEffect(() => {
		setNCells(props.nCells ? props.nCells : 2);
	}, [props.nCells]);

	return (
		<Container style={props.style}>
			<CellRow>
				{props.options
					.slice(
						isMobile ? 0 : index * nCells,
						isMobile
							? props.options.length
							: index * nCells + nCells
					)
					.map((item, i) => (
						<PressCell
							key={"press-" + i}
							press={item}
							nCells={nCells}
						/>
					))}
			</CellRow>
			<ButtonRow>
				<Button
					style={{
						borderRadius: 100,
						height: 40,
						width: 40,
						border: `1px solid ${ColorV2.border.neutralSoft}`,
					}}
					design="image"
					icon={<ChevronLeft />}
					disabled={index <= 0}
					onClick={() => {
						if (index > 0) setIndex(index - 1);
					}}
				/>
				<Button
					style={{
						borderRadius: 100,
						height: 40,
						width: 40,
						border: `1px solid ${ColorV2.border.neutralSoft}`,
					}}
					design="image"
					icon={<ChevronRight />}
					onClick={() => {
						if ((index + 1) * nCells < props.options.length)
							setIndex(index + 1);
						else setIndex(0);
					}}
				/>
			</ButtonRow>
		</Container>
	);
};
export default PressList;
export interface Props {
	style?: React.CSSProperties;
	options: Array<PressCellProps["press"]>;
	nCells?: number;
}
